import React, { useState } from 'react'
import { getFileExtension } from '../../utils/filters'
import HowToGuidesItem from './how_to_guides_item'

const HowToGuides = ({ results }) => {
  const [selected, setSelected] = useState(null)
  const [content, setContent] = useState('')

  const onSelectItem = async (item, index) => {
    if (selected === index) {
      setSelected(null)
    } else {
      await getReadme(item.file)
      setSelected(index)
    }
  }

  const getReadme = async (file) => {
    if (getFileExtension(file) === 'md') {
      const response = await window.fetch(file)
      const content = await response.text()
      setContent(content)
    }
  }

  return (
    <div className={'documentation-block'}>
      <div className={'documentation-block-title'}>
        <div className={'documentation-block-title__icon'}>
          <i className='fa fa-question fa-4x' aria-hidden='true' />
        </div>
        <h2>HowTo Guides</h2>
      </div>
      <div>
        {results.map((item, index) => (
          <HowToGuidesItem
            key={index}
            title={item.title}
            isOpen={index === selected}
            content={content}
            onToggle={() => onSelectItem(item, index)}
          />
        ))}
      </div>
    </div>
  )
}

export default HowToGuides
